const o = "_commentCard_1oa90_1", t = "_long_1oa90_10", n = "_short_1oa90_14", s = {
  commentCard: o,
  long: t,
  short: n
};
export {
  o as commentCard,
  s as default,
  t as long,
  n as short
};
//# sourceMappingURL=styles.module.scss.js.map
